<template>
<div class="rental-price" >
<md-switch v-model="inputAvailable" v-if="rentalVideo"></md-switch>

<div class="rental-type">
    <div class="md-subheading">Type</div>
    <md-radio class="md-primary" v-model="trailerModel" :md-value="false">Video</md-radio>
    <md-radio class="md-primary" v-model="trailerModel" :md-value="true">Trailer</md-radio>
</div>
<md-input-container >
        <label for="price">Rental price</label>
        <md-select v-model="selectedOption" :disabled="!inputAvailable || isTrailer" @input="emitSelection">
            <md-option v-for="option in prices" :value="option" :key='option'>
                $ {{ formatPrice(option) }}
            </md-option>
        </md-select>
</md-input-container>
</div>
</template>

<script>

export default {
props: {
    rentalVideo: {
    type: Boolean,
    default: false
    },
    price: {
    type: Number,
    },
    isTrailer: {
    type: Boolean,
    default: false
    },
},
data() {
    return {
    selectedOption: null,
    inputAvailable: true,
    prices: [],
    };
},
computed: {
    trailerModel: {
        get() {
            return this.isTrailer;
        },
        set(value) {
            this.$emit('update:isTrailer', value);
            if (value) {
                this.selectedOption = null;
                this.$emit('price-selected', null);
            }
        }
    }
},
methods: {
    formatPrice(amount) {
        return (amount / 100).toFixed(2);
    },
    emitSelection() {
        this.$emit('price-selected', this.selectedOption);
    },
    generatePrices(){
        for (let i = 99; i <= 1999; i+=100) {
            this.prices.push(i);
        }
    }
},


mounted() {
    this.generatePrices();
    if(this.price && !this.isTrailer) { this.selectedOption = this.price }
},

watch: {
    price(newPrice) {
        if (this.isTrailer) return;
        if (newPrice) {
            this.selectedOption = newPrice;
            this.emitSelection();
        }
    },
    isTrailer(isTrailer) {
        if (isTrailer) {
            this.selectedOption = null;
        }
    }
}
};
</script>

<style lang="scss" scoped>
.rental-price {
    display: flex;
    flex-direction: column;
    .rental-type {
        display: flex;
        flex-wrap: wrap;
        .md-subheading {
            flex-basis: 100%;
        }
        .md-radio {
            margin-right: 16px;
            flex-shrink: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/shared-components/forms/RentalPricingForm.vue